<template>
  <div style="margin: 0 48px 8px 24px;">
    <el-form ref="formRef" :model="paramForm" label-width="auto" label-position="right">
      <el-form-item label="参数名称：">
        <el-input v-model="paramForm.name" placeholder="请输入参数名称" />
      </el-form-item>
      <el-form-item label="参数代码：">
        <el-input type="textarea" :rows="4" v-model="paramForm.keyCode" placeholder="请输入参数代码" />
      </el-form-item>
      <el-form-item label="参数说明：">
        <el-input type="textarea" :rows="4" v-model="paramForm.description" placeholder="请输入参数说明" />
      </el-form-item>
      <el-form-item label="参数配置：">
        <el-input type="textarea" :rows="4" v-model="paramForm.config" placeholder="请输入参数配置" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" :disabled="loading" v-loading="loading" >确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import { addOrUpdateSysParam} from "@/api/url";
import { positiveIntReg } from "@/assets/shared/reg-constant";

export default {
  name: "BannerDialog",
  props: {
    value: Object
  },
  data() {
    return {
      paramForm: this.value.paramForm,
      idx: this.value.ids,
      loading: false
    }
  },
  methods: {

    disabledDate(time) {
      let today = new Date()

      return time.getTime() < (today.getTime() - 24*60*60*1000)
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.paramForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '参数名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.paramForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '参数代码不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = {};
      param['id'] = this.idx > -1?this.paramForm.id:0;
      param['keyCode'] = this.paramForm.keyCode;
      param['name'] = this.paramForm.name;
      param['config'] = this.paramForm.config;
      param['description'] = this.paramForm.description;
      postFormData(addOrUpdateSysParam, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}
</style>
